"use client";

import { FunctionComponent } from "react";
import { RegisterOptions, useController } from "react-hook-form";
import { InputText, InputTextProps } from "./input-text";

export interface InputTextFieldProps extends InputTextProps {
    /**
     * Name of the input field.
     */
    name: string;

    /**
     * Controller
     */
    control?: any;

    /**
     * Rules of the input field.
     */
    rules?: RegisterOptions;
}

export const InputTextField: FunctionComponent<InputTextFieldProps> = ({
    id,
    name,
    label,
    hideLabel,
    tooltip,
    required,
    onClear,
    control,
    rules,
    ...restProps
}) => {
    const {
        field,
        fieldState: { error },
    } = useController({
        name,
        control,
        rules: rules,
    });

    return (
        <InputText
            onChange={field.onChange}
            onBlur={field.onBlur}
            onClear={onClear}
            value={field.value}
            id={id}
            label={label}
            hideLabel={hideLabel}
            required={required}
            tooltip={tooltip}
            name={field.name}
            error={error?.message}
            {...restProps}
            ref={field.ref}
        />
    );
};
